var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Board',{attrs:{"game":"fll","board":_vm.board.number,"options":_vm.options},on:{"board":_vm.setBoard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }